<template>
  <div class="formSetting">
    <main-item :id="detail.id" :default-value="detail.proportion"></main-item>
    <a-collapse
      class="custom-collapse"
      v-model="activeKey"
      :bordered="false"
    >
      <template #expandIcon="props">
        <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
      </template>
      <a-collapse-panel
        v-for="item in detail.children"
        :key="item.id"
        :header="item.name"
      >
        <main-item :id="item.id" :default-value="item.proportion"></main-item>

        <a-space class="indicator-space">
          <div class="label">指标配置：</div>
          <div style="width: 100%">
            <indicator-setting
              :detail="item"
            ></indicator-setting>
          </div>
        </a-space>

      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import MainItem from './MainItem.vue'
import IndicatorSetting from './IndicatorSetting.vue'

export default {
  name: 'FormSetting',
  components: {
    MainItem,
    IndicatorSetting
  },
  props: {
    detail: {
      type: Object
    }
  },
  data () {
    return {
      activeKey: this.detail.children.map(item => item.id)
    }
  },
  methods: {
    fetchIndicatorList () {
    }
  }
}
</script>

<style lang="less" scoped>
.formSetting {
  padding: 0 16px;

  .custom-collapse {
    background: #fff;
    :deep(.ant-collapse-item) {
      border-bottom: none;
      margin-bottom: 12px;
      .ant-collapse-header {
        padding: 8px 16px !important;
        border-radius: 8px;
        background: #e8f3ff;
        .ant-collapse-arrow {
          right: 16px !important;
        }
      }
      .ant-collapse-content {
        background-color: #fff;
        padding: 12px 6px 8px 6px;
        .indicator-space {
          width: 100%;
          align-items: flex-start;
          .ant-space-item:last-of-type {
            flex: 1;
          }
          .label {
            width: 80px;
          }
        }
      }
    }
  }
}
</style>
